"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jwtDecode = require("jwt-decode");
var Raven = require("raven-js");
var Cookies = require("js-cookie");
var storage_1 = require("./../storage");
exports.TOKEN_NAME = '__JWT__';
exports.VAAS_TOKEN_NAME = 'vaas_jwt';
exports.getToken = function () {
    try {
        return storage_1.default.getItem(exports.TOKEN_NAME);
    }
    catch (error) {
        return null;
    }
};
exports.getDecodedToken = function () {
    var token = exports.getToken();
    if (!token) {
        return;
    }
    try {
        return jwtDecode(token);
    }
    catch (err) {
        Raven.captureException(err);
        return;
    }
};
function getTokenProperty(key) {
    var decodedToken = exports.getDecodedToken();
    return decodedToken ? decodedToken[key] : undefined;
}
exports.getTokenProperty = getTokenProperty;
exports.getCurrentUser = function () {
    return getTokenProperty('user');
};
exports.getIntercomHash = function () {
    return getTokenProperty('intercom_hash');
};
exports.login = function (token) {
    storage_1.default.setItem(exports.TOKEN_NAME, token);
    var currentUser = exports.getCurrentUser();
    var userContext = {
        name: currentUser && currentUser.name,
        email: currentUser && currentUser.email,
        uuid: currentUser && currentUser.uuid,
    };
    Raven.setUserContext(userContext);
};
exports.logout = function () {
    Raven.setUserContext();
    storage_1.default.removeItem(exports.TOKEN_NAME);
};
exports.isAuthenticated = function () {
    var decodedToken = exports.getDecodedToken();
    if (!decodedToken) {
        return false;
    }
    if (!decodedToken.exp || decodedToken.exp < Date.now() / 1000) {
        return false;
    }
    return true;
};
exports.getMainDomain = function (domain) {
    var localhost = 'localhost';
    if (domain === localhost) {
        return localhost;
    }
    var mainDomainLevels = 2;
    return "." + domain
        .split('.')
        .slice(-mainDomainLevels)
        .join('.');
};
exports.isAuthenticatedByCookie = function () {
    var domain = exports.getMainDomain(window.location.hostname);
    var token;
    try {
        token = Cookies.get(exports.VAAS_TOKEN_NAME, { domain: domain });
    }
    catch (error) {
        return false;
    }
    if (!token) {
        return false;
    }
    var decodedToken;
    try {
        decodedToken = jwtDecode(token);
    }
    catch (err) {
        Raven.captureException(err);
        return false;
    }
    if (!decodedToken) {
        return false;
    }
    if (!decodedToken.exp || decodedToken.exp < Date.now() / 1000) {
        return false;
    }
    return true;
};
exports.checkAuthStatus = function (lo) {
    if (lo === void 0) { lo = exports.logout; }
    if (!exports.isAuthenticated()) {
        lo();
        return false;
    }
    return true;
};
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-fns/dist/auth/auth.js
// module id = 102
// module chunks = 0